import { EventType } from "../../constants/event-type-constants";
import ReadLaterService from "./service";
import ReadLaterView from "./view";
import Tooltip from "../../tooltip/module";
import { ArticleParameters } from "./recommendations-cop";
import { ReadLaterConstants } from "../../constants/read-later-constants";
import CopBox from "./cop-box";
import { DOMHelper } from "../../helpers/dom-helper";

export default class ReadLater {
    readLaterButtonsClass: string;
    isLoggedIn: boolean;

    articleIdList: Array<number> = [];
    articleTotal: number = 0;
    capUserElement: HTMLElement;
    countArticleElement: HTMLElement;

    constructor(readLaterButtonsClass: string) {
        this.readLaterButtonsClass = readLaterButtonsClass;
        this.isLoggedIn = Boolean(document.body.dataset.logged);
    }

    init() {
        if (this.isLoggedIn) {
            this.capUserElement = DOMHelper.querySelector(ReadLaterConstants.capUserSelector) as HTMLElement;
            this.countArticleElement = DOMHelper.querySelector(ReadLaterConstants.countArticleSelector) as HTMLElement;
        }
    }

    initializeReadLaterButton(buttonParams: ArticleParameters, button: HTMLElement): void {
        if (button && this.isLoggedIn) {
            this.handleButtonClick(button, buttonParams);
        } else {
            this.hideButtons(button);
        }
    }

    bindReadLaterEvents(boxes: Array<CopBox>) {
        boxes.forEach((box: CopBox) => {
            this.bindBox(box);
        })
    }

    bindBox(box: CopBox) {
        const button = box.elements.readLaterButton;

        this.initializeReadLaterButton(box.articleParameters, button);
        this.setButtonState(button);
        this.addDatasetXX(box.elements.anchors[0], button);
    }

    hideButtons(button: HTMLElement) {
        if (button) {
            button.style.display = ReadLaterConstants.displayNone;
            button.innerHTML = ReadLaterConstants.emptyString;
        }
    }

    handleButtonClick(button: HTMLElement, buttonParams: ArticleParameters) {
        button.addEventListener(EventType.CLICK, (e: MouseEvent) => {
            e.preventDefault();
            this.toggle(button, e, buttonParams.articleId, buttonParams.pageUrl);
        });
    }

    async toggle(button: HTMLElement, event: MouseEvent, xx: number, url: string): Promise<void> {
        if (!this.isLoggedIn || !button) {
            return;
        }

        const index: number = this.articleIdList.indexOf(xx);
        event.preventDefault();

        if (index >= 0) {
            if (await ReadLaterService.remove(xx)) {
                this.articleIdList.splice(index, 1);
                button.classList.remove(ReadLaterConstants.buttonInListClass);
                Tooltip.show(button, ReadLaterConstants.articleDeletedFromStorage);
                localStorage.setItem(ReadLaterConstants.localStorageKey, JSON.stringify(this.articleIdList));
                this.countArticleElement.dataset.chip = this.articleIdList.length.toString();
            }
        } else {
            if (await ReadLaterService.add(xx, url)) {
                this.articleIdList.push(xx);
                button.classList.add(ReadLaterConstants.buttonInListClass);
                Tooltip.show(button, ReadLaterConstants.articleAddedToStorage);
                localStorage.setItem(ReadLaterConstants.localStorageKey, JSON.stringify(this.articleIdList));
                this.countArticleElement.dataset.chip = this.articleIdList.length.toString();
                ReadLaterView.doAnimation(button, this.capUserElement);
            }
        }
    }

    addDatasetXX(anchor: HTMLAnchorElement, button: HTMLElement) {
        if (anchor && button) {
            button.dataset.xx = anchor?.href?.split(",")[2];
        }
    }

    async setButtonState(button: HTMLElement): Promise<void> {
        if (!this.isLoggedIn || !button) {
            return;
        }

        this.getLocalStorageData(button);
        this.getServerData(button);
    }

    getLocalStorageData(button: HTMLElement): void {
        try {
            this.articleIdList = JSON.parse(localStorage.getItem(ReadLaterConstants.localStorageKey)!);
            this.articleTotal = this.articleIdList.length;

            button.classList.toggle(ReadLaterConstants.buttonInListClass, this.articleIdList.indexOf(Number(button.dataset.xx)) >= 0);
            this.countArticleElement.dataset.chip = this.articleIdList.length.toString();
        } catch (e) {
            console.log("%cReadLater", "color: #faa", "no local saved articles");
        }
    }

    async getServerData(button: HTMLElement): Promise<void> {
        const { list, total } = await ReadLaterService.list(Number(document.body.dataset.xx));

        this.articleIdList = list;
        this.articleTotal = total;

        button.classList.toggle(ReadLaterConstants.buttonInListClass, this.articleIdList.indexOf(Number(button.dataset.xx)) >= 0);
        this.countArticleElement.dataset.chip = this.articleTotal.toString();
    }
}